
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as wishlist0oKfk8Bm9u2a0LDWUpIJm7oEopHDx6AAdS1ADyj_7NgMeta } from "/workspace/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93G3UImlrGEn_AkohTrBuwPuH5aat5XwRr38Zf6Rv18ggMeta } from "/workspace/pages/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/workspace/pages/wishlist.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/workspace/pages/[...slug].vue")
  }
]